import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import Typogaphy from "../Typography/Typography";
import { useDeleteAction, useGetChangeStatusApp } from "../../hooks/useCrm";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
const initValue = {
  IdS0alesOpportunities: null,
  StatusApps: null,
};
export const AppStatusChangeModal = ({ show, handleClose, id }) => {
  const [button] = useState(false);
  const [form, setForm] = useState(initValue);
  const { mutateAsync: changeStatus } = useGetChangeStatusApp();
  useEffect(() => {
    setForm({ ...form, IdS0alesOpportunities: id });
  }, [id]);
  const handleChangeStatus = (data) => {
    changeStatus(data).then(() => setForm({ ...form, StatusApps: null }));
  };
  return (
    <BootstrapModal
      modaltitle="تغییر وضعیت اپلیکیشن"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <Typogaphy size="14px">آیا اپلیکیشن را نصب کرده اند؟</Typogaphy>
        </div>
        <div className="col-12 mt-2">
          <SimpleSelect1
            res={[
              { value: 0, label: "خیر" },
              { value: 1, label: "بله" },
            ]}
            onChange={(e) => setForm({ ...form, StatusApps: e.value })}
          />
        </div>
        <div className="col-12 d-flex justify-content-end">
          <Button
            bgColor="#009ef7"
            color="#fff"
            small="60px"
            style={{ padding: "4px" }}
            onclick={() => {
              handleChangeStatus(form);
              handleClose();
            }}
          >
            ثبت
          </Button>
          <Button
            bgColor="#f1416c"
            color="#fff"
            small="60px"
            style={{ padding: "4px", marginRight: "10px" }}
            onclick={handleClose}
          >
            انصراف
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
